import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import CopyCard from "../components/CopyCard";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone} from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';

function Trade() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [copyExperts, setCopyExperts] = useState([]);
  const [myCopy, setMyCopy] = useState([]);
  useEffect(() => {
    const fetchCopyData = async () => {
      try {
        const myCopyRes = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchMyCopytrade: true })
        });
        const myCopyData = await myCopyRes.json();
        if (myCopyData.status !== "success") {
          toast.error('Error fetching your copytrade data!');
          return;
        }
        const myCopyList = myCopyData.copytrade;
        setMyCopy(myCopyList);
        const allExpertsRes = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchCopytrade: true })
        });
        const allExpertsData = await allExpertsRes.json();
        if (allExpertsData.status !== "success") {
          toast.error('Error fetching expert traders!');
          return;
        }
        const expertList = allExpertsData.copytrade;
        const copiedTraderIds = myCopyList.map(item => item.trader_id);   
        const updatedExperts = expertList.map(trader => ({
          ...trader,
          copy: copiedTraderIds.includes(trader.trade_id)
        }));
        setCopyExperts(updatedExperts);
      } catch (err) {
        toast.error('Something went wrong fetching copytrade data!');
      }
    };
    if (user) {
      fetchCopyData();
    }
  }, [user]);
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Copy Experts" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Copy Experts" icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <h5 className="fw-bold text-white mt-5 mb-3 ms-2">Experts</h5>
            <div className="row">
              {copyExperts.map((expert) => (
                <div className="col-lg-4 col-6 col-12">
                     <CopyCard key={expert.id} trade_id={expert.trade_id} photo1={expert.photo} image={<img src={`/uploads/${expert.trader_photo}`} alt={expert.trader_name} width="100%" height="100%" style={{objectFit:'cover'}} />} name={expert.trader_name} winrate={expert.win_rate} profit={expert.profit_share} win={expert.win} loss={expert.loss} copy={expert.copy} price={expert.price} badge_color={expert.badge_color} trades={expert.trades} description={expert.description} username={expert.username} followers={expert.followers}/>
                </div>
              ))}
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Trade